import range from "lodash/range";
import { generateColorScale, getElevation, rem, remRhythm } from "../css"; // Fonts

var font = '"Hind Vadodara", "Helvetica", "Arial", "sans-serif"'; // Colors

var blue = "#2f8aac";
var blues = generateColorScale(blue);
var green = "#00866b";
var greens = generateColorScale(green);
var red = "#d22a15";
var reds = generateColorScale(red);
var orange = "#d1892a";
var oranges = generateColorScale(orange);
var charcoal = "#8c8980";
var charcoals = generateColorScale(charcoal);
var gray = "#999";
var grays = generateColorScale(gray);
var backgroundColor = "#f7f7f7";
var borderColor = grays[100];
var ruleColor = grays[200];
var mutedColor = gray;
var textColor = charcoals[800];
var headingColor = charcoals[900];
var infoColor = blue;
var successColor = green;
var warningColor = orange;
var errorColor = red;
var white = "#fff";
var black = "#000";
var brown = "#673201"; // Legacy Colors

var legacyCharcoal = "#2e2c26";
var legacyCharcoalGray = "#57554f";
var legacyTextColor = legacyCharcoalGray;
var legacyHeadingColor = legacyCharcoal;
var legacyBackgroundColor = "#f0efed";
var legacyBorderColor = "#d8d8d8"; // @ts-ignore: Figure out how to initialize this Array with properties

var breakpoints = ["480px", "600px", "800px"];
breakpoints.xs = "320px";
breakpoints.sm = "480px";
breakpoints.md = "600px";
breakpoints.lg = "800px";
breakpoints.xl = "1280px";
breakpoints.xxl = "1600px";
var theme = {
  breakpoints: breakpoints,
  radii: {
    sm: "2px",
    md: "4px",
    lg: "8px"
  },
  fonts: {
    text: font,
    heading: font
  },
  fontSizes: {
    xxs: rem(11),
    xs: rem(13),
    sm: rem(14),
    md: rem(16),
    lg: rem(20),
    xl: rem(26),
    xxl: rem(32)
  },
  lineHeights: {
    solid: "1em",
    heading: "1.25em",
    text: "1.5em"
  },
  fontWeights: {
    normal: 300,
    bold: 700
  },
  space: {
    // Backwards compatibility with array index access
    "0": 0,
    "1": remRhythm(1 / 8),
    "2": remRhythm(1 / 4),
    "3": remRhythm(1 / 2),
    "4": remRhythm(1),
    "5": remRhythm(1 + 1 / 2),
    "6": remRhythm(2),
    "7": remRhythm(3),
    "8": remRhythm(4),
    // Preferred way of accessing spacing values
    none: 0,
    xxs: remRhythm(1 / 8),
    xs: remRhythm(1 / 4),
    sm: remRhythm(1 / 2),
    md: remRhythm(1),
    lg: remRhythm(1 + 1 / 2),
    xl: remRhythm(2),
    xxl: remRhythm(3),
    xxxl: remRhythm(4)
  },
  elevations: range(25).map(getElevation),
  colors: {
    blue: blue,
    blues: blues,
    blueHover: "#2fabd7",
    bluePressed: blues[700],
    blueSelected: blues[900],
    green: green,
    greens: greens,
    greenHover: "#0eb08f",
    greenPressed: greens[700],
    greenSelected: greens[900],
    red: red,
    reds: reds,
    redHover: "#f7331a",
    redPressed: reds[700],
    redSelected: reds[900],
    orange: orange,
    oranges: oranges,
    orangeHover: "#f49f2f",
    orangePressed: oranges[700],
    orangeSelected: oranges[900],
    charcoal: charcoal,
    charcoals: charcoals,
    gray: gray,
    grays: grays,
    white: white,
    black: black,
    brown: brown,
    // UI Colors
    background: backgroundColor,
    border: borderColor,
    rule: ruleColor,
    muted: mutedColor,
    text: textColor,
    heading: headingColor,
    info: infoColor,
    success: successColor,
    warning: warningColor,
    error: errorColor,
    // Legacy Colors
    legacyCharcoal: legacyCharcoal,
    legacyCharcoalGray: legacyCharcoalGray,
    legacyText: legacyTextColor,
    legacyHeading: legacyHeadingColor,
    legacyBackground: legacyBackgroundColor,
    legacyBorder: legacyBorderColor
  },
  zIndices: {
    dropdown: 1000,
    sticky: 1100,
    fixed: 1200,
    modalOverlay: 1290,
    modal: 1300,
    popover: 1400,
    tooltip: 1500,
    toast: 1600
  }
};
export default theme;